var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowStarHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7884 9.11744C38.0313 2.24905 28.2797 2.30428 26.3756 9.19908L23.8585 18.3132L14.1916 18.3679C6.7498 18.4101 4.3276 27.9918 10.6923 32.21L18.5773 37.4357L16.1733 46.1403C14.2522 53.0962 22.5118 58.9612 28.2716 54.731L36.0519 49.017L44.5348 54.6389C50.8146 58.8008 58.3418 52.8465 55.5603 45.9172L52.0795 37.2459L59.3115 31.9346C65.1492 27.6473 61.5416 18.0997 54.0998 18.1419L44.4329 18.1966L40.7884 9.11744Z",
    fill: "#FFCB5F",
    stroke: "#AA3B82",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStarHovered);
export default __webpack_public_path__ + "static/media/yellowStarHovered.e6f928483c9e45fde81fcf70d2816012.svg";
export { ForwardRef as ReactComponent };